import { render, staticRenderFns } from "./buttonGroup.vue?vue&type=template&id=3ffaf6cc&"
import script from "./buttonGroup.vue?vue&type=script&lang=js&"
export * from "./buttonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports